<template>
  <div>
    <header-image
      :headerContents="headerContents"
      :headerBackground="'work'"
    />

    <call-out-box
      :CallOutTitle="'Half of our team are former rare clients or candidates'"
    />
    <call-out-box
      :CallOutTitle="'Valued. Fulfilled. Family. Fun. Friends. Inspired. Energised. Proud. Happy.'"
      :CallOutBody="'We asked people how they feel about working here. That’s what they said.'"
      :CallOutBodySmall="'We asked people how they feel about working here. That’s what they said.'"
      :CallOutColor="'midgrey'"
    />


    <div class="grid-container full">
      <div class="grid-x">
        <div class="small-12 text-center">
          <h2 class="top">Current vacancies</h2>
        </div>
      </div>
    </div>


   <div class="grid-container full page-contents-8">
      <div class="grid-x">
        <div class="small-12 text-center page-contents-15">
          <rare-standard-button
            class="rolesButton show-for-small-only"
            :tabIndex="20"
            :active="'true'"
            :buttonText="'View open vacancies'"
            :height="'40px'"
            :width="'160px'"
            :fontColor="'#ffffff'"
            :fontSize="'12px'"
            @clicked="openAppForm('https://rare.appx.candidats.io/roles')"
          />
          <rare-standard-button
            class="rolesButton show-for-medium"
            :tabIndex="20"
            :active="'true'"
            :buttonText="'View open vacancies'"
            :height="'64px'"
            :width="'282px'"
            :fontColor="'#ffffff'"
            :fontSize="'16px'"
            @clicked="openAppForm('https://rare.appx.candidats.io/roles')"
          />
        </div>
      </div>
    </div>

    <div class="grid-container full">
      <div class="grid-x">
        <div class="small-12 text-center page-contents-15">
          <h2 class="bottom">Speculative applications</h2>
          <p class="spec">
            We are always looking for the very best people to join us. If you would like to work for Rare, please send us a CV and cover letter. Tell us why you want to join Rare, in what sort of role, and how you would add value in that role. Please include your availability.
          </p>

          <rare-standard-button
            class="applyButton show-for-small-only"
            :tabIndex="21"
            :active="'true'"
            :buttonText="'Apply now'"
            :height="'40px'"
            :width="'160px'"
            :fontColor="'#ffffff'"
            :fontSize="'12px'"
            @clicked="openAppForm('https://rare.appx.candidats.io/apply/13fb6a52-6b37-48e6-8daf-a47cee8d6c16')"
          />
          <rare-standard-button
            class="applyButton show-for-medium"
            :tabIndex="21"
            :active="'true'"
            :buttonText="'Apply now'"
            :height="'64px'"
            :width="'282px'"
            :fontColor="'#ffffff'"
            :fontSize="'16px'"
            @clicked="openAppForm('https://rare.appx.candidats.io/apply/13fb6a52-6b37-48e6-8daf-a47cee8d6c16')"
          />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RareStandardButton from '@/components/atoms/RareWebButton';

import HeaderHeroImage from '../../components/header/HeaderHeroImage';
import RareCallOutBox from '../../components/commonSections/RareCallOutBox';
import RareWorkHeaderContents from './components/RareWorkForRareHeaderContents';

import RareWorkJobTemplate from './components/jobs/RareWorkJobTemplate';

export default {
  name: 'workForRare',
  components: {
    'header-image': HeaderHeroImage,
    'call-out-box': RareCallOutBox,
    'rare-work-header-contents': RareWorkHeaderContents,
    'rare-standard-button': RareStandardButton,
    'rare-job-template': RareWorkJobTemplate,
  },
  data() {
    return {
      headerContents: 'rare-work-header-contents',
      workForUsFormFormOpen: false,
      oldYPos: 0,
      jobTitle: null,
    };
  },
  methods: {
    openAppForm(url) {
      window.open(url, '_blank');
    },
    closeWorkForUsFormForm() {
      window.scrollTo(0, this.oldYPos);
      this.workForUsFormFormOpen = false;
    },

  },
  mounted() {
    this.$emit('hideNavigation');
  },
  destroyed() {
    this.$emit('showNavigation');
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  h2 {
    color: $main-text;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
  }

  p.spec {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
  }

  .jobsCont {
      border-top: 1px solid #c4cace;
  }

  @media only screen and (max-width: 640px)  {

    h2 {
      font-size: 28px;
      line-height: 1.43;
      letter-spacing: 0.2px;

      text-align: center;
    }

    h2.top {
      margin: 48px 0 24px 0;
    }

    h2.bottom {
      margin: 48px 0 24px 0;
    }

    p.spec {
      font-size: 14px;
      line-height: 1.43;
      letter-spacing: 0.2px;
      margin-bottom: 16px;
    }

    .applyButton, .rolesButton {
      margin: 0 auto 48px auto;
    }

  }

  @media only screen and (min-width: 641px) {

    h2 {
      font-size: 56px;
      line-height: 1.29;
      letter-spacing: 0.8px;

    }

    h2.top {
      margin: 96px 0 30px 0;
    }

    h2.bottom {
      margin: 80px 0 24px 0;
    }

    p.spec {
      font-size: 21px;
      line-height: 1.52;
      letter-spacing: 0.4px;
      margin-bottom: 36px;
    }

    .applyButton {
      margin: 0 auto 96px auto;
    }

    .rolesButton {
      margin: 0 auto 0 auto;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/workForRare/workForRare.vue